// @flow
export { default } from './FakeBannerCard';



// WEBPACK FOOTER //
// ./src/components/common/FakeBannerCard/index.js